module.exports = __webpack_public_path__ + "media/partners/3m-e13776c5.svg";